<template>
    <div class="input-group">
        <div class="dropdown bootstrap-select">
            <button type="button" :class="['btn', 'dropdown-toggle', 'select-picker', cssClass || '']"
                data-toggle="dropdown" role="button" title="Sort by Date" aria-expanded="false">
                <div class="filter-option">
                    <div class="filter-option-inner">
                        <div class="filter-option-inner-inner">{{ _.get(value, 'text', label) }}</div>
                    </div>
                </div>
            </button>
            <div class="dropdown-menu" role="combobox" x-placement="bottom-start">
                <div class="inner show" role="listbox" aria-expanded="false" tabindex="-1">
                    <ul class="dropdown-menu inner show">
                        <li class="selected active">
                            <a role="option" v-on:click="() => $emit('input', null)"
                               class="dropdown-item selected"
                               aria-disabled="false" tabindex="0" aria-selected="true">
                                <span class=" bs-ok-default check-mark"></span>
                                <span class="text">{{ label }}</span>
                            </a>
                        </li>
                        <li v-for="option in values" class="selected active">
                            <a role="option" v-on:click="() => $emit('input', option)"
                               class="dropdown-item selected"
                               aria-disabled="false" tabindex="0" aria-selected="true">
                                <span class=" bs-ok-default check-mark"></span>
                                <span class="text">{{ option.text }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import UtilsMixin from '../UtilsMixin';

export default {
    props: ['value', 'values', 'label', 'cssClass'],

    mixins: [UtilsMixin],
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/form/SelectBoxComponent.vue